/**
 * Bloque de subida compartido por los flujos de IA. Sin Card: el contenido de la pestaña ya vive
 * dentro del Card del detalle de causa.
 */
const SubidaDocumentos = ({
  DesignSystemComponents,
  titulo,
  ayuda,
  archivos,
  onArchivos,
  onAnalizar,
  cargando,
  error,
  etiquetaBoton,
  etiquetaCargando,
  t,
  // Se dibuja entre el selector de archivos y el botón: lo que el abogado declara antes de analizar.
  antesDelBoton,
}) => {
  const { Button, Alert } = DesignSystemComponents || {};

  return (
    <div className='d-flex flex-column gap-3'>
      <div>
        <div className='fw-semibold'>{titulo}</div>
        {ayuda && <div className='color-gray-600 small'>{ayuda}</div>}
        <input
          type='file'
          accept='application/pdf'
          multiple
          className='form-control mt-2'
          onChange={(e) => onArchivos(Array.from(e.target.files || []))}
        />
      </div>

      {antesDelBoton}

      <div>
        <Button
          label={cargando ? etiquetaCargando : etiquetaBoton}
          size='sm'
          variant='primary'
          onClick={onAnalizar}
          disabled={!archivos.length || cargando}
        />
        {/* Medido: el análisis de un expediente de 7 documentos tardó 252 segundos. Sin decirlo,
            cuatro minutos con el botón deshabilitado se leen como "se colgó". */}
        {cargando && (
          <div className='caption color-gray-600 mt-2'>{t('cw_upload_wait')}</div>
        )}
      </div>

      {error && <Alert className='alerta-en-linea' variant='danger'>{error}</Alert>}
    </div>
  );
};

export default SubidaDocumentos;
